export default __webpack_public_path__ + "static/media/ovalEffect.a7deeeef.png";